// Mock Data for Medical Clinic Management System

// Patients Data (20 entries)
export const PATIENTS_DATA = [
  {
    id: 1,
    fullName: "Ahmed Mohamed Hassan",
    gender: "Male",
    dob: "1985-03-15",
    phone: "+20 100 123 4567",
    email: "ahmed.hassan@email.com",
    address: "15 El Tahrir St, Cairo, Egypt",
    bloodType: "A+",
    lastVisit: "2025-12-20",
    chronicDiseases: ["Diabetes"]
  },
  {
    id: 2,
    fullName: "Fatima Ali Ibrahim",
    gender: "Female",
    dob: "1990-07-22",
    phone: "+20 122 456 7890",
    email: "fatima.ali@email.com",
    address: "42 Ramses St, Alexandria, Egypt",
    bloodType: "O+",
    lastVisit: "2026-01-15",
    chronicDiseases: ["Hypertension"]
  },
  {
    id: 3,
    fullName: "Omar Khaled Mahmoud",
    gender: "Male",
    dob: "1978-11-30",
    phone: "+20 111 234 5678",
    email: "omar.khaled@email.com",
    address: "88 Pyramids Rd, Giza, Egypt",
    bloodType: "B+",
    lastVisit: "2026-01-28",
    chronicDiseases: []
  },
  {
    id: 4,
    fullName: "Sarah Johnson",
    gender: "Female",
    dob: "1995-02-14",
    phone: "+1 555 123 4567",
    email: "sarah.johnson@email.com",
    address: "123 Main St, New York, USA",
    bloodType: "AB+",
    lastVisit: "2025-11-10",
    chronicDiseases: []
  },
  {
    id: 5,
    fullName: "Youssef Ahmed Salem",
    gender: "Male",
    dob: "1982-06-08",
    phone: "+20 106 789 0123",
    email: "youssef.salem@email.com",
    address: "27 Nile Corniche, Luxor, Egypt",
    bloodType: "A-",
    lastVisit: "2026-01-25",
    chronicDiseases: ["Diabetes", "Hypertension"]
  },
  {
    id: 6,
    fullName: "Layla Hassan Abdel",
    gender: "Female",
    dob: "1988-09-17",
    phone: "+20 127 345 6789",
    email: "layla.hassan@email.com",
    address: "56 University St, Mansoura, Egypt",
    bloodType: "O-",
    lastVisit: "2025-12-05",
    chronicDiseases: []
  },
  {
    id: 7,
    fullName: "Michael Smith",
    gender: "Male",
    dob: "1970-12-25",
    phone: "+44 20 7123 4567",
    email: "michael.smith@email.com",
    address: "45 Baker St, London, UK",
    bloodType: "B-",
    lastVisit: "2026-01-30",
    chronicDiseases: ["Hypertension"]
  },
  {
    id: 8,
    fullName: "Nour Mohamed Farouk",
    gender: "Female",
    dob: "1993-04-11",
    phone: "+20 114 567 8901",
    email: "nour.farouk@email.com",
    address: "33 Port Said St, Ismailia, Egypt",
    bloodType: "A+",
    lastVisit: "2026-01-18",
    chronicDiseases: []
  },
  {
    id: 9,
    fullName: "Khaled Samir Zaki",
    gender: "Male",
    dob: "1975-08-29",
    phone: "+20 101 890 1234",
    email: "khaled.zaki@email.com",
    address: "78 El Haram St, Giza, Egypt",
    bloodType: "O+",
    lastVisit: "2025-11-22",
    chronicDiseases: ["Diabetes"]
  },
  {
    id: 10,
    fullName: "Mariam Youssef Ali",
    gender: "Female",
    dob: "1987-01-05",
    phone: "+20 128 901 2345",
    email: "mariam.youssef@email.com",
    address: "91 Zamalek St, Cairo, Egypt",
    bloodType: "AB-",
    lastVisit: "2026-02-01",
    chronicDiseases: []
  },
  {
    id: 11,
    fullName: "Hassan Omar Khalil",
    gender: "Male",
    dob: "1965-10-18",
    phone: "+20 109 012 3456",
    email: "hassan.khalil@email.com",
    address: "12 Maadi St, Cairo, Egypt",
    bloodType: "B+",
    lastVisit: "2025-12-15",
    chronicDiseases: ["Hypertension", "Diabetes"]
  },
  {
    id: 12,
    fullName: "Emma Williams",
    gender: "Female",
    dob: "1992-05-20",
    phone: "+1 555 234 5678",
    email: "emma.williams@email.com",
    address: "789 Oak Ave, Los Angeles, USA",
    bloodType: "A+",
    lastVisit: "2026-01-22",
    chronicDiseases: []
  },
  {
    id: 13,
    fullName: "Amr Tarek Hussein",
    gender: "Male",
    dob: "1980-03-07",
    phone: "+20 115 123 4567",
    email: "amr.hussein@email.com",
    address: "64 Nasr City, Cairo, Egypt",
    bloodType: "O-",
    lastVisit: "2026-01-12",
    chronicDiseases: []
  },
  {
    id: 14,
    fullName: "Salma Ibrahim Nasser",
    gender: "Female",
    dob: "1998-07-31",
    phone: "+20 129 234 5678",
    email: "salma.nasser@email.com",
    address: "25 Downtown, Alexandria, Egypt",
    bloodType: "A-",
    lastVisit: "2025-11-28",
    chronicDiseases: []
  },
  {
    id: 15,
    fullName: "Ali Mahmoud Shafik",
    gender: "Male",
    dob: "1972-11-12",
    phone: "+20 102 345 6789",
    email: "ali.shafik@email.com",
    address: "18 Heliopolis, Cairo, Egypt",
    bloodType: "B+",
    lastVisit: "2026-01-05",
    chronicDiseases: ["Diabetes"]
  },
  {
    id: 16,
    fullName: "Dina Khaled Rashed",
    gender: "Female",
    dob: "1986-02-28",
    phone: "+20 123 456 7890",
    email: "dina.rashed@email.com",
    address: "50 Garden City, Cairo, Egypt",
    bloodType: "AB+",
    lastVisit: "2026-01-27",
    chronicDiseases: []
  },
  {
    id: 17,
    fullName: "Mohamed Sayed Farid",
    gender: "Male",
    dob: "1991-09-09",
    phone: "+20 110 567 8901",
    email: "mohamed.farid@email.com",
    address: "37 6th October City, Egypt",
    bloodType: "O+",
    lastVisit: "2025-12-30",
    chronicDiseases: []
  },
  {
    id: 18,
    fullName: "Hoda Gamal Adel",
    gender: "Female",
    dob: "1977-12-03",
    phone: "+20 125 678 9012",
    email: "hoda.adel@email.com",
    address: "43 Sheraton, Cairo, Egypt",
    bloodType: "A+",
    lastVisit: "2026-01-08",
    chronicDiseases: ["Hypertension"]
  },
  {
    id: 19,
    fullName: "Tarek Ahmed Mostafa",
    gender: "Male",
    dob: "1984-04-16",
    phone: "+20 107 789 0123",
    email: "tarek.mostafa@email.com",
    address: "71 New Cairo, Egypt",
    bloodType: "B-",
    lastVisit: "2026-02-02",
    chronicDiseases: []
  },
  {
    id: 20,
    fullName: "Rana Said Mahmoud",
    gender: "Female",
    dob: "1994-06-24",
    phone: "+20 126 890 1234",
    email: "rana.mahmoud@email.com",
    address: "22 Dokki, Giza, Egypt",
    bloodType: "O+",
    lastVisit: "2026-01-20",
    chronicDiseases: []
  }
];

// Appointments Data (50 entries)
export const APPOINTMENTS_DATA = [
  // November 2025
  {
    id: 1,
    patientId: 4,
    doctorName: "Dr. Ahmed El-Shazly",
    date: "2025-11-05",
    time: "09:00",
    type: "Consultation",
    status: "Completed"
  },
  {
    id: 2,
    patientId: 6,
    doctorName: "Dr. Mona Hassan",
    date: "2025-11-08",
    time: "10:30",
    type: "Follow-up",
    status: "Completed"
  },
  {
    id: 3,
    patientId: 9,
    doctorName: "Dr. Karim Nasser",
    date: "2025-11-12",
    time: "11:00",
    type: "Consultation",
    status: "Completed"
  },
  {
    id: 4,
    patientId: 11,
    doctorName: "Dr. Sarah Mohamed",
    date: "2025-11-15",
    time: "14:00",
    type: "Follow-up",
    status: "Completed"
  },
  {
    id: 5,
    patientId: 14,
    doctorName: "Dr. Omar Fahmy",
    date: "2025-11-18",
    time: "15:30",
    type: "Consultation",
    status: "Completed"
  },
  {
    id: 6,
    patientId: 9,
    doctorName: "Dr. Ahmed El-Shazly",
    date: "2025-11-22",
    time: "09:30",
    type: "Follow-up",
    status: "Completed"
  },
  {
    id: 7,
    patientId: 14,
    doctorName: "Dr. Layla Abdel",
    date: "2025-11-25",
    time: "10:00",
    type: "Consultation",
    status: "Completed"
  },
  {
    id: 8,
    patientId: 6,
    doctorName: "Dr. Mona Hassan",
    date: "2025-11-28",
    time: "13:00",
    type: "Follow-up",
    status: "Completed"
  },
  // December 2025
  {
    id: 9,
    patientId: 1,
    doctorName: "Dr. Sarah Mohamed",
    date: "2025-12-02",
    time: "09:00",
    type: "Follow-up",
    status: "Completed"
  },
  {
    id: 10,
    patientId: 6,
    doctorName: "Dr. Ahmed El-Shazly",
    date: "2025-12-05",
    time: "10:30",
    type: "Consultation",
    status: "Completed"
  },
  {
    id: 11,
    patientId: 11,
    doctorName: "Dr. Karim Nasser",
    date: "2025-12-08",
    time: "11:00",
    type: "Follow-up",
    status: "Completed"
  },
  {
    id: 12,
    patientId: 15,
    doctorName: "Dr. Omar Fahmy",
    date: "2025-12-10",
    time: "14:00",
    type: "Consultation",
    status: "Completed"
  },
  {
    id: 13,
    patientId: 11,
    doctorName: "Dr. Sarah Mohamed",
    date: "2025-12-15",
    time: "15:00",
    type: "Follow-up",
    status: "Completed"
  },
  {
    id: 14,
    patientId: 1,
    doctorName: "Dr. Ahmed El-Shazly",
    date: "2025-12-20",
    time: "09:30",
    type: "Follow-up",
    status: "Completed"
  },
  {
    id: 15,
    patientId: 17,
    doctorName: "Dr. Mona Hassan",
    date: "2025-12-22",
    time: "10:00",
    type: "Consultation",
    status: "Completed"
  },
  {
    id: 16,
    patientId: 5,
    doctorName: "Dr. Layla Abdel",
    date: "2025-12-28",
    time: "13:30",
    type: "Emergency",
    status: "Completed"
  },
  {
    id: 17,
    patientId: 17,
    doctorName: "Dr. Karim Nasser",
    date: "2025-12-30",
    time: "14:00",
    type: "Follow-up",
    status: "Completed"
  },
  // January 2026
  {
    id: 18,
    patientId: 15,
    doctorName: "Dr. Omar Fahmy",
    date: "2026-01-05",
    time: "09:00",
    type: "Follow-up",
    status: "Completed"
  },
  {
    id: 19,
    patientId: 18,
    doctorName: "Dr. Sarah Mohamed",
    date: "2026-01-08",
    time: "10:30",
    type: "Consultation",
    status: "Completed"
  },
  {
    id: 20,
    patientId: 13,
    doctorName: "Dr. Ahmed El-Shazly",
    date: "2026-01-12",
    time: "11:00",
    type: "Consultation",
    status: "Completed"
  },
  {
    id: 21,
    patientId: 2,
    doctorName: "Dr. Mona Hassan",
    date: "2026-01-15",
    time: "14:00",
    type: "Follow-up",
    status: "Completed"
  },
  {
    id: 22,
    patientId: 8,
    doctorName: "Dr. Karim Nasser",
    date: "2026-01-18",
    time: "15:30",
    type: "Consultation",
    status: "Completed"
  },
  {
    id: 23,
    patientId: 12,
    doctorName: "Dr. Layla Abdel",
    date: "2026-01-22",
    time: "09:30",
    type: "Consultation",
    status: "Completed"
  },
  {
    id: 24,
    patientId: 5,
    doctorName: "Dr. Omar Fahmy",
    date: "2026-01-25",
    time: "10:00",
    type: "Follow-up",
    status: "Completed"
  },
  {
    id: 25,
    patientId: 16,
    doctorName: "Dr. Sarah Mohamed",
    date: "2026-01-27",
    time: "13:00",
    type: "Consultation",
    status: "Completed"
  },
  {
    id: 26,
    patientId: 3,
    doctorName: "Dr. Ahmed El-Shazly",
    date: "2026-01-28",
    time: "14:30",
    type: "Consultation",
    status: "Completed"
  },
  {
    id: 27,
    patientId: 7,
    doctorName: "Dr. Mona Hassan",
    date: "2026-01-30",
    time: "09:00",
    type: "Follow-up",
    status: "Completed"
  },
  // February 2026 (Past appointments)
  {
    id: 28,
    patientId: 10,
    doctorName: "Dr. Karim Nasser",
    date: "2026-02-01",
    time: "10:30",
    type: "Consultation",
    status: "Completed"
  },
  {
    id: 29,
    patientId: 19,
    doctorName: "Dr. Layla Abdel",
    date: "2026-02-02",
    time: "11:00",
    type: "Consultation",
    status: "Completed"
  },
  // February 2026 (Upcoming appointments)
  {
    id: 30,
    patientId: 1,
    doctorName: "Dr. Ahmed El-Shazly",
    date: "2026-02-03",
    time: "09:00",
    type: "Follow-up",
    status: "Confirmed"
  },
  {
    id: 31,
    patientId: 4,
    doctorName: "Dr. Omar Fahmy",
    date: "2026-02-05",
    time: "10:30",
    type: "Consultation",
    status: "Confirmed"
  },
  {
    id: 32,
    patientId: 2,
    doctorName: "Dr. Sarah Mohamed",
    date: "2026-02-07",
    time: "11:00",
    type: "Follow-up",
    status: "Pending"
  },
  {
    id: 33,
    patientId: 8,
    doctorName: "Dr. Mona Hassan",
    date: "2026-02-10",
    time: "14:00",
    type: "Consultation",
    status: "Confirmed"
  },
  {
    id: 34,
    patientId: 5,
    doctorName: "Dr. Karim Nasser",
    date: "2026-02-12",
    time: "15:30",
    type: "Follow-up",
    status: "Confirmed"
  },
  {
    id: 35,
    patientId: 11,
    doctorName: "Dr. Ahmed El-Shazly",
    date: "2026-02-14",
    time: "09:30",
    type: "Surgery",
    status: "Confirmed"
  },
  {
    id: 36,
    patientId: 13,
    doctorName: "Dr. Layla Abdel",
    date: "2026-02-15",
    time: "10:00",
    type: "Consultation",
    status: "Pending"
  },
  {
    id: 37,
    patientId: 7,
    doctorName: "Dr. Omar Fahmy",
    date: "2026-02-17",
    time: "13:30",
    type: "Follow-up",
    status: "Confirmed"
  },
  {
    id: 38,
    patientId: 16,
    doctorName: "Dr. Sarah Mohamed",
    date: "2026-02-18",
    time: "14:00",
    type: "Consultation",
    status: "Pending"
  },
  {
    id: 39,
    patientId: 9,
    doctorName: "Dr. Mona Hassan",
    date: "2026-02-20",
    time: "09:00",
    type: "Follow-up",
    status: "Confirmed"
  },
  {
    id: 40,
    patientId: 12,
    doctorName: "Dr. Karim Nasser",
    date: "2026-02-21",
    time: "10:30",
    type: "Consultation",
    status: "Cancelled"
  },
  {
    id: 41,
    patientId: 14,
    doctorName: "Dr. Ahmed El-Shazly",
    date: "2026-02-23",
    time: "11:00",
    type: "Emergency",
    status: "Confirmed"
  },
  {
    id: 42,
    patientId: 18,
    doctorName: "Dr. Layla Abdel",
    date: "2026-02-24",
    time: "14:00",
    type: "Follow-up",
    status: "Confirmed"
  },
  {
    id: 43,
    patientId: 15,
    doctorName: "Dr. Omar Fahmy",
    date: "2026-02-25",
    time: "15:30",
    type: "Consultation",
    status: "Pending"
  },
  {
    id: 44,
    patientId: 3,
    doctorName: "Dr. Sarah Mohamed",
    date: "2026-02-26",
    time: "09:30",
    type: "Consultation",
    status: "Confirmed"
  },
  {
    id: 45,
    patientId: 6,
    doctorName: "Dr. Mona Hassan",
    date: "2026-02-27",
    time: "10:00",
    type: "Follow-up",
    status: "Confirmed"
  },
  {
    id: 46,
    patientId: 10,
    doctorName: "Dr. Karim Nasser",
    date: "2026-02-28",
    time: "13:00",
    type: "Consultation",
    status: "Pending"
  },
  // March 2026
  {
    id: 47,
    patientId: 17,
    doctorName: "Dr. Ahmed El-Shazly",
    date: "2026-03-01",
    time: "09:00",
    type: "Follow-up",
    status: "Confirmed"
  },
  {
    id: 48,
    patientId: 19,
    doctorName: "Dr. Layla Abdel",
    date: "2026-03-02",
    time: "10:30",
    type: "Consultation",
    status: "Pending"
  },
  {
    id: 49,
    patientId: 20,
    doctorName: "Dr. Omar Fahmy",
    date: "2026-03-03",
    time: "11:00",
    type: "Surgery",
    status: "Confirmed"
  },
  {
    id: 50,
    patientId: 1,
    doctorName: "Dr. Sarah Mohamed",
    date: "2026-03-05",
    time: "14:00",
    type: "Follow-up",
    status: "Cancelled"
  }
];

// Chart Data
export const CHART_DATA = {
  // Daily visit counts for the last 7 days (Jan 27 - Feb 2, 2026)
  dailyVisits: {
    labels: ['Jan 27', 'Jan 28', 'Jan 29', 'Jan 30', 'Jan 31', 'Feb 1', 'Feb 2'],
    datasets: [
      {
        label: 'Daily Visits',
        data: [12, 15, 8, 14, 10, 18, 13],
        backgroundColor: 'rgba(54, 162, 235, 0.6)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1
      }
    ]
  },

  // Appointment type distribution (Pie Chart)
  appointmentDistribution: {
    labels: ['Consultation', 'Follow-up', 'Emergency', 'Surgery'],
    datasets: [
      {
        label: 'Appointment Types',
        data: [22, 20, 2, 2], // Total: 22 Consultation, 20 Follow-up, 2 Emergency, 2 Surgery
        backgroundColor: [
          'rgba(54, 162, 235, 0.6)',   // Blue for Consultation
          'rgba(75, 192, 192, 0.6)',   // Teal for Follow-up
          'rgba(255, 99, 132, 0.6)',   // Red for Emergency
          'rgba(255, 206, 86, 0.6)'    // Yellow for Surgery
        ],
        borderColor: [
          'rgba(54, 162, 235, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(255, 99, 132, 1)',
          'rgba(255, 206, 86, 1)'
        ],
        borderWidth: 1
      }
    ]
  },

  // Monthly appointments trend
  monthlyTrend: {
    labels: ['Nov 2025', 'Dec 2025', 'Jan 2026', 'Feb 2026', 'Mar 2026'],
    datasets: [
      {
        label: 'Monthly Appointments',
        data: [8, 9, 12, 17, 4],
        backgroundColor: 'rgba(153, 102, 255, 0.6)',
        borderColor: 'rgba(153, 102, 255, 1)',
        borderWidth: 1
      }
    ]
  },

  // Appointment status distribution
  statusDistribution: {
    labels: ['Completed', 'Confirmed', 'Pending', 'Cancelled'],
    datasets: [
      {
        label: 'Status Distribution',
        data: [29, 13, 6, 2],
        backgroundColor: [
          'rgba(75, 192, 192, 0.6)',   // Green for Completed
          'rgba(54, 162, 235, 0.6)',   // Blue for Confirmed
          'rgba(255, 206, 86, 0.6)',   // Yellow for Pending
          'rgba(255, 99, 132, 0.6)'    // Red for Cancelled
        ],
        borderColor: [
          'rgba(75, 192, 192, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(255, 99, 132, 1)'
        ],
        borderWidth: 1
      }
    ]
  }
};
